import { render, staticRenderFns } from "./copywritingModel.vue?vue&type=template&id=3f029b42"
import script from "./copywritingModel.vue?vue&type=script&lang=js"
export * from "./copywritingModel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3f029b42')) {
      api.createRecord('3f029b42', component.options)
    } else {
      api.reload('3f029b42', component.options)
    }
    module.hot.accept("./copywritingModel.vue?vue&type=template&id=3f029b42", function () {
      api.rerender('3f029b42', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/insurance/insuranceManage/mainFrom/copywritingModel.vue"
export default component.exports